var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailReplyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 19",
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.761 3.317a.2.2 0 0 1 0-.315L7.52.043A.2.2 0 0 1 7.843.2v1.734a.2.2 0 0 0 .198.2l.504.005c2.056.022 3.768.224 4.949.79.575.276 1.005.63 1.297 1.08.291.45.473 1.041.473 1.837 0 .717-.32 1.46-.794 2.08-.122.159-.357.036-.333-.163.136-1.1-.112-2.013-.9-2.674-.518-.435-1.203-.695-1.97-.853-.773-.16-1.683-.227-2.704-.24l-.518-.007a.2.2 0 0 0-.202.2v1.93a.2.2 0 0 1-.324.157l-3.758-2.96zm-1.339.753H3.49l4.193 3.5c.39.327 1.008.063 1.008-.445v-2.16c3.938.055 5.636 1 4.484 4.562-.128.396.367.702.713.458.176-.124.349-.265.516-.422v3.82c0 1.489-1.082 2.689-2.379 2.689H2.422c-1.34 0-2.422-1.2-2.422-2.689V6.758C0 5.27 1.081 4.07 2.422 4.07zm10.553 3.89-4.758 3.504c-.303.192-.649.336-.995.336-.389 0-.735-.144-1.038-.336L1.427 7.96A.786.786 0 0 1 1.34 7a.601.601 0 0 1 .822-.145l4.758 3.553a.54.54 0 0 0 .648 0l4.758-3.553c.303-.192.649-.096.822.24.13.24.086.625-.173.865z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailReplyIcon);
export default ForwardRef;